import React from "react";
import dayjs from "dayjs";

import { isNullOrUndefined } from "../../HWLibrary/HWUtils";

function MessageA96(props) {
  const onMouseEnter = (e) => {
    if (!e.target) {
      return;
    }
    if (e.target.disabled === true) {
      return;
    }

    e.target.style.color = props.config?.customDesign?.messageA96ButtonMouseEnter.color ?? "#f8f5f5";
    e.target.style.backgroundColor = props.config?.customDesign?.messageA96ButtonMouseEnter.background ?? "#2935dd";
  };

  const onMouseLeave = (e) => {
    if (!e.target) {
      return;
    }

    e.target.style.color = props.config?.customDesign?.messageA96ButtonMouseLeave.color ?? "#0092ed";
    e.target.style.backgroundColor = props.config?.customDesign?.messageA96ButtonMouseLeave.background ?? "#fff";
  };

  const messageContainerClassName = () => {
    return props.config.autoFullScreen ? "s360-message-cotainer-received-fs" : "s360-message-cotainer-received";
  };

  const messageBoxStyle = () => {
    return {
      textAlign: "left",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "#0092ed",
      width: "fit-content",
      borderRadius: 20,
      color: "#0092ed",
      backgroundColor: "#fff",
      fontWeight: "500",
      ...props.config?.customDesign?.messageA96Box
    };
  };

  const messageTimeStyle = () => {
    let config = props.config;
    return config?.customDesign?.messageA96Time;
  };

  const onMessageSend = (oneOption) => {
    let n = document.getElementsByClassName("btn btn-chat");
    for (let i = 0; i < n.length; i++) {
      n[i].disabled = true;
      onMouseLeave({ target: n[i] });
    }
    props.actions.sendMessageWithCode(oneOption.value,{ name:oneOption.name,value:oneOption.value });
  };

  const isActiveConversation = () => {
    let isClosed =
      (props.activeConversation &&
        props.activeConversation.active != null &&
        props.activeConversation.active !== undefined &&
        props.activeConversation.active === false) ||
      props.isConversationClosed;
    return !isClosed;
  };

  const data = isNullOrUndefined(
    this?.props?.entry && this?.props?.entry?.text_data?.data
  )
    ? []
    : this?.props?.entry && this?.props?.entry?.text_data?.data;
  return (
    <div className={messageContainerClassName()}>
      {data?.length !== 0 &&
        data.map((oneData) => (
          <button
            key={oneData.name}
            disabled={props.disabled}
            className="btn btn-chat btn-check"
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            style={messageBoxStyle()}
            {...(isActiveConversation() && {
              onClick: () => onMessageSend(oneData),
            })}
          >
            {oneData.name}
            <br />
          </button>
        ))}
      {props.isLastEntry && props.sentTimestamp && (
        <div
          className="s360-message-time-received"
          style={messageTimeStyle()}
        >
          {dayjs
            .unix(Math.trunc(props.sentTimestamp / 1000))
            .format("DD MMM h:mm a")}
        </div>
      )}
    </div>
  );
}

export default MessageA96;
